import api from "@/api";
import {
  formatPhoneNumberForApi,
  removeLeading1OnPhoneNumberForClientUse,
} from "@/util.js";

const state = () => ({
  info: null,
});

const nullifyAddressIfNotParsedSoUserMustReenterIntoGoogleAutocomplete = (
  user
) => {
  if (!user.address || !user.address.address) {
    return null;
  }
  return { ...user.address };
};

const actions = {
  async fetch({ commit, dispatch }) {
    const data = await api({
      url: "/123/users/account",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("INIT", data.info);
  },
  async update({ commit, dispatch }, info) {
    const d = {
      ...info,
      ...(info.phone && { phone: formatPhoneNumberForApi(info.phone) }),
    };
    const data = await api({
      data: d,
      method: "PUT",
      url: "/123/users",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : !info.password && commit("UPDATE", info);
  },
};

const mutations = {
  CLEAR(state) {
    state.info = null;
  },
  INIT(state, user) {
    state.info = {
      ...user,
      address:
        nullifyAddressIfNotParsedSoUserMustReenterIntoGoogleAutocomplete(user),
      phone: removeLeading1OnPhoneNumberForClientUse(user.phone),
    };
  },
  UPDATE(state, info) {
    state.info = {
      ...state.info,
      ...info,
    };
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations
};
